<template>
  <button
    class="tw:shadow-[0px_4px_16px_0px_rgba(0,0,0,0.3)] tw:md:shadow-none tw:h-[52px] tw:md:h-[56px] tw:w-[52px] tw:md:w-auto tw:text-white tw:text-center tw:font-bold tw:bg-black tw:md:py-4 tw:md:px-6 tw:flex tw:justify-center tw:items-center tw:gap-4 tw:rounded-full tw:md:rounded-b-none tw:md:rounded-t-xl tw:cursor-pointer"
    @click="onChatButtonClick">
    <template v-if="isChatOpen">
      <Close class="tw:size-3.5" />
      <span>{{ $t('chatbot_close') }}</span>
    </template>
    <template v-else>
      <ChatIcon class="tw:size-7" />
      <span class="tw:hidden tw:md:inline">{{ $t('chatbot_start') }}</span>
    </template>
  </button>
</template>

<script setup>
import Close from '@/components/icons/Close.svg?component'
import ChatIcon from '@/components/icons/ChatIcon.svg?component'
import useChat from '@/components/chatbot/useChat'

import appAnalytics from '@/utils/tracking'

const { isChatOpen, conversationId } = useChat()

const onChatButtonClick = () => {
  if (!isChatOpen.value) {
    appAnalytics.track(appAnalytics.events.CHAT_LETS_TALK_CLICKED, { conversation_id: conversationId.value })
  } else {
    appAnalytics.track(appAnalytics.events.CHAT_CLOSE_CLICKED, { conversation_id: conversationId.value })
  }

  isChatOpen.value = !isChatOpen.value
}
</script>
